export default "__VITE_ASSET__DetCgr9J__"